import $ from "jquery";

export default {
    name: "ajout-entres",
    components: {},
    props: [],
    data() {
        return {
          loading: false,
          filtered_articles: [],
          entres: [],
          value: "",
          is_empty: false,
          receptionStockId: null,
          receptionStockError: "",
        };
    },
    computed: {
        //Old function
        article() {
            return this.$store.getters["all_articles"];
        },

        //New function
        liste_all_articles() {
            return this.$store.getters["liste_all_articles"];
        },

        fournisseurs() {
            return this.$store.getters["fournisseurs"];
        },
        stocks() {
            return this.$store.getters["stocks"] || [];
        },
        receptionRole() {
            const activeRole = this.$store.getters["activeRole"];
            if (activeRole && activeRole.nom) return activeRole.nom;
            const authInfo = this.$store.getters["authInfo"];
            const roles = authInfo && authInfo.user && authInfo.user.roles || [];
            if (roles.some(role => role.nom === "ROLE_RESPONSABLE_LOGISTIQUE")) return "ROLE_RESPONSABLE_LOGISTIQUE";
            if (roles.some(role => role.nom === "ROLE_ADMINISTRATEUR")) return "ROLE_ADMINISTRATEUR";
            return roles.length === 1 ? roles[0].nom : null;
        },
        canChooseReceptionStock() {
            return this.receptionRole === "ROLE_RESPONSABLE_LOGISTIQUE" ||
                this.receptionRole === "ROLE_ADMINISTRATEUR";
        },
        isLogistics() {
            return this.receptionRole === "ROLE_RESPONSABLE_LOGISTIQUE";
        },
        receptionStocks() {
            return this.isLogistics
                ? this.stocks.filter(stock => stock.code === "magasin-central")
                : this.stocks;
        },
        receptionStockName() {
            const stock = this.stocks.find(item => item.id === this.receptionStockId);
            return stock ? stock.nom : "Chargement…";
        },
        retourStock() {
            const stockId = Number(this.$route && this.$route.query && this.$route.query.stock);
            return Number.isInteger(stockId) && stockId > 0 && this.stocks.some(stock => Number(stock.id) === stockId)
                ? "/stock/show/" + stockId : "/entres";
        },
    },

    mounted() {
        this.$store.dispatch("getAllListesArticles")

        this.$store.dispatch("getFournisseurs");
        this.loadReceptionStocks();

        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);
    },

    methods: {
        async loadReceptionStocks() {
            this.receptionStockId = null;
            this.receptionStockError = "";
            try {
                const stocks = await this.$store.dispatch("getStocks");
                const disponibles = Array.isArray(stocks) ? stocks : this.stocks;
                const code = this.canChooseReceptionStock ? "magasin-central" : "pharmacie";
                const destination = disponibles.find(stock => stock.code === code);
                const legacyPharmacy = !this.isLogistics && disponibles.find(stock => Number(stock.id) === 1);
                const stockId = Number(this.$route && this.$route.query && this.$route.query.stock);
                const demande = disponibles.find(stock => Number(stock.id) === stockId);
                const autorise = demande && (!this.isLogistics || demande.code === "magasin-central");
                this.receptionStockId = autorise ? demande.id : (destination ? destination.id : (legacyPharmacy ? legacyPharmacy.id : null));
                if (!this.receptionStockId) {
                    this.receptionStockError = this.isLogistics
                        ? "Le Magasin central est indisponible. Contactez l'administrateur avant d'enregistrer une entrée."
                        : "Aucun emplacement de réception n'est disponible.";
                }
            } catch (error) {
                this.receptionStockError = "Impossible de charger les emplacements de stock. Réessayez.";
            }
        },
        /**
         * @deprecated
         */
        filterArticle() {
            this.filtered_articles = [];

            if (this.value.length > 1) {
                this.liste_all_articles.forEach((article) => {
                    if (
                        article.article_nom.toLowerCase().includes(this.value.toLowerCase())
                    ) {
                        this.filtered_articles.push(article);
                    }
                });
            }

            this.is_empty = false;
        },

        choiceArticle(article) {
            this.entres.push({
                article: article.article_id,
                libelle: article.article_nom,
                fournisseur: null,
                nombre: null,
                peremption: null,
            });
            this.value = "";
            this.filtered_articles = [];
        },

        deleteEntre(index) {
            this.entres.splice(index, 1);
        },

        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            if (this.entres.length == 0) {
              this.is_empty = true;
              return;
            }

            if (!this.receptionStockId) {
                this.receptionStockError = "Choisissez un emplacement de réception avant de valider.";
                return;
            }
            
            
                this.loading = true;

                const data = {
                    articles: this.entres.map(entre => ({ ...entre, stock: this.receptionStockId })),
                };

                try {
                    const response = await this.$store.dispatch("saveEntre", data);
                    if (response) this.$router.push({ path: this.retourStock });
                } finally {
                    this.loading = false;
                }
            
        },
    },
};
